const mutations = {
  // 设置公告列表
  muSetMessage(state, payload) {
    state.message = payload;
  }
};
export default mutations;
